import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import { TrendingUp, Security, Bolt, Storage } from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#0f172a',
        color: '#94a3b8',
        pt: 8,
        pb: 5,
        borderTop: '1px solid #1e293b',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} md={5}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box
                sx={{
                  p: 1,
                  borderRadius: 2,
                  bgcolor: 'rgba(16, 185, 129, 0.12)',
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                  display: 'flex',
                }}
              >
                <TrendingUp sx={{ color: '#34d399', fontSize: 24 }} />
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  color: '#ffffff',
                  fontFamily: '"Space Grotesk", sans-serif',
                }}
              >
                FiMod
              </Typography>
            </Box>

            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3, maxWidth: 360, lineHeight: 1.6 }}>
              Cutting-edge software for UK real estate financial modelling, automated 1D & 2D sensitivity matrices, macro scenario stress-testing, and smart model document management.
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#34d399', boxShadow: '0 0 8px #34d399' }} />
              <Typography variant="caption" sx={{ color: '#34d399', fontFamily: 'monospace', fontWeight: 700 }}>
                ALL SYSTEMS OPERATIONAL • UK LONDON REGION
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', fontWeight: 700, mb: 2 }}>
              Capabilities
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" sx={{ color: '#94a3b8' }}>1D & 2D Sensitivity Heatmaps</Typography>
              <Typography variant="body2" sx={{ color: '#94a3b8' }}>Macro Scenario Stress Tests</Typography>
              <Typography variant="body2" sx={{ color: '#94a3b8' }}>UK SDLT Tax Engine</Typography>
              <Typography variant="body2" sx={{ color: '#94a3b8' }}>Model Version Control</Typography>
              <Typography variant="body2" sx={{ color: '#94a3b8' }}>Institutional Cashflow Exports</Typography>
            </Box>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography variant="subtitle2" sx={{ color: '#ffffff', fontWeight: 700, mb: 2 }}>
              UK Compliance & Infrastructure
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Security sx={{ color: '#60a5fa', fontSize: 18 }} />
                <Typography variant="body2" sx={{ color: '#94a3b8' }}>UK Data Protection & Privacy Compliant</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Storage sx={{ color: '#34d399', fontSize: 18 }} />
                <Typography variant="body2" sx={{ color: '#94a3b8' }}>Secure Encrypted UK Infrastructure</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Bolt sx={{ color: '#a78bfa', fontSize: 18 }} />
                <Typography variant="body2" sx={{ color: '#94a3b8' }}>Financial Calculation Engine</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: '#1e293b', mb: 3 }} />

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="caption" sx={{ color: '#64748b' }}>
            © {new Date().getFullYear()} FiMod Technologies Ltd. All rights reserved. Registered in England & Wales.
          </Typography>
          <Typography variant="caption" sx={{ color: '#64748b' }}>
            Designed for UK Private Equity & Real Estate Institutions
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
